/* Progressive enhancement; page and FAQ remain usable without JavaScript. */
(() => {
  if (window.__maisonHomeLoaded) return;
  window.__maisonHomeLoaded = true;
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    const sections = [...(root.matches?.('[data-ml-section]') ? [root] : []), ...root.querySelectorAll('[data-ml-section]')];
    for (const section of sections) {
      if (instances.has(section)) continue;
      const controller = new AbortController();
      const cleanup = [];
      if (section.hasAttribute('data-ml-animate') && !reduced.matches && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('ml-reveal-in'); observer.unobserve(entry.target); }
        }), { threshold: 0.08 });
        section.querySelectorAll('[data-ml-reveal]').forEach(el => {
          // Hero is immediately visible; animate only genuinely below-the-fold content.
          if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('ml-reveal-pending'); observer.observe(el); }
        });
        cleanup.push(() => observer.disconnect());
        const showAll = () => section.querySelectorAll('.ml-reveal-pending').forEach(el => el.classList.add('ml-reveal-in'));
        reduced.addEventListener('change', showAll, { signal: controller.signal });
      }
      section.querySelectorAll('[data-ml-carousel]').forEach(carousel => {
        const track = carousel.querySelector('.ml-track');
        const prev = carousel.querySelector('[data-ml-prev]');
        const next = carousel.querySelector('[data-ml-next]');
        const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
        const move = dir => track.scrollBy({ left: dir * ((track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + 22), behavior: reduced.matches ? 'instant' : 'smooth' });
        prev.addEventListener('click', () => move(-1), {signal:controller.signal});
        next.addEventListener('click', () => move(1), {signal:controller.signal});
        track.addEventListener('scroll', update, {passive:true,signal:controller.signal});
        track.addEventListener('keydown', event => {if(event.key === 'ArrowRight' || event.key === 'ArrowLeft'){event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}}, {signal:controller.signal});
        if ('ResizeObserver' in window) {const observer=new ResizeObserver(update);observer.observe(track);cleanup.push(()=>observer.disconnect());}
        update();
      });
      instances.set(section, () => { controller.abort(); cleanup.forEach(fn=>fn()); });
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of instances) if (event.target.contains(section)) {cleanup();instances.delete(section);}
  });
  document.addEventListener('shopify:block:select', event => {
    const block = event.target;
    if (block.matches('details')) block.open = true;
    if (block.closest('.ml-track')) block.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
  });
  document.querySelectorAll('.ml-menu nav a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
  document.addEventListener('keydown', event => { if(event.key === 'Escape') document.querySelectorAll('.ml-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();}); });
})();
